<div class="chart-card">
  @if (!isLoading) {
    <div class="chart-header">
      <div class="chart-title-section">
        <div class="title-and-trend">
          <h3 class="chart-title">{{ title }}</h3>
          @if (hasData()) {
            <app-graph-trend-icon
              [percentageChange]="percentageChange"
              [formattedChange]="formatPercentChange()"
              [formatValue]="formatValue(totalValue)"
              [isUptrendPositive]="isUptrendPositive()">
            </app-graph-trend-icon>
          }
        </div>
        <button class="btn-expand" (click)="openModal()">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.33333 3.33333H6.66667V2H2V6.66667H3.33333V3.33333ZM6.66667 12.6667H3.33333V9.33333H2V14H6.66667V12.6667ZM14 9.33333H12.6667V12.6667H9.33333V14H14V9.33333ZM12.6667 6.66667H14V2H9.33333V3.33333H12.6667V6.66667Z" fill="#9FA1A4"/>
          </svg>
        </button>
      </div>
    </div>
  } @else {
    <ng-container [ngTemplateOutlet]="noDataTitle"></ng-container>
  }

  <ng-template #noDataTitle>
    <div class="chart-header">
      <div class="chart-title-section">
        <h3 class="chart-title">{{ title }}</h3>
      </div>
    </div>
  </ng-template>

  <div class="chart-body">
    @defer (on timer(100ms)) {
      @if (!isLoading && hasData()) {
        <app-multi-line-chart
          [data]="chartData"
          [series]="series"
          [legend]="legendItems"
          [xAxisKey]="'label'"
          [chartHeight]="175"
          [yTicks]="yTicks"
          [scrollableLegend]="true"
          [tooltipFormat]="formatTooltipValue"
        />
      } @else if (!isLoading && !hasData()) {
        <div class="d-flex align-items-center justify-content-center no-data">
          <app-empty-state></app-empty-state>
        </div>
      }
    }
  </div>

  @if (isLoading) {
    <div class="card-loader">
      <div class="spinner-border text-primary" role="status"></div>
    </div>
  }
</div>